import React from 'react';

const Footer = () => {
    return (
        <footer className="bg-neutral-900 pt-16 pb-8">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <p className="text-gray-400 text-sm text-center">
                    © 2024 URLBite. All rights reserved.
                </p>
            </div>
        </footer>
    );
};

export default Footer;
